export const ROUTER_NAME = 'router';

/**
 * @param {Object} rootState
 * @return {ReduxUIRouterState}
 */
export function getRouter(rootState) {
  return rootState[ROUTER_NAME];
}

/**
 * @param {Object} rootState
 * @return {String}
 */
export function getStateName(rootState) {
  return getRouter(rootState).currentState.name;
}

/**
 * @param {Object} rootState
 * @return {Object}
 */
export function getStateParams(rootState) {
  return getRouter(rootState).currentParams;
}

/**
 * @typedef {Object} ReduxUIRouterState
 * @property {Object} currentState
 * @property {String} currentState.name
 * @property {Object} currentParams
 */

/**
 * @typedef {Object} ReduxUIState
 * @property {String} name
 */

/**
 * @typedef {Object} RouterState
 * @property {ReduxUIState} currentState
 * @property {Object} currentParams
 */



// WEBPACK FOOTER //
// ./src/js/config/reducers/state.js